import memoize from 'memoizee';

import type CK from '~/types/contentking';

import {
	type AccountWebsiteSizesQuery,
	useAccountWebsiteSizesQuery,
} from './useAccountWebsiteSizes.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



const format = memoize(
	(data: AccountWebsiteSizesQuery | undefined) => {
		const account = data?.account ?? null;
		const websites = account?.websites ?? null;

		if (websites === null) {
			return null;
		}

		// Use backend-calculated pageBundleUsage as single source of truth.
		// This ensures the displayed value matches what the backend uses for validation.
		// Note: pageBundleUsage is null for accounts without page bundle feature.
		const totalPageCapacity = account?.pageBundleUsage ?? 0;

		return {
			totalPageCapacity,
			websites,
		};
	},
);



function useAccountWebsiteSizes(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountWebsiteSizesQuery,
		accountId,
	);

	return format(data);
}



export default useAccountWebsiteSizes;
